export const isBetweenJobsDBMigrationCutOff = (
  createdDateString: string,
): boolean => {
  const JOBSDB_JOBS_WITH_NO_APPLICATIONS_MIGRATION_END_DATE =
    '2022-01-01T00:00:01';
  const createdDate = new Date(createdDateString);
  return (
    createdDate < new Date(JOBSDB_JOBS_WITH_NO_APPLICATIONS_MIGRATION_END_DATE)
  );
};

export const isBetweenJobStreetMigrationCutOff = (
  createdDateString: string,
): boolean => {
  const JOBSTREET_JOBS_WITH_NO_APPLICATIONS_MIGRATION_END_DATE =
    '2022-10-02T00:00:01';
  const createdDate = new Date(createdDateString);
  return (
    createdDate <
    new Date(JOBSTREET_JOBS_WITH_NO_APPLICATIONS_MIGRATION_END_DATE)
  );
};
